import Vue from "vue";
import VueRouter from "vue-router";

import DefaultLayout from "../layouts/default";
import LoginLayout from "../layouts/login";

import Login from "../views/Login";
import Companies from "../views/Companies";
import Company from "../views/Company";
import CompanyJoinRequest from "../views/CompanyJoinRequest";
import FeedOutList from "../views/FeedOutList";
import Sandbox from "../views/Sandbox";
import Dashboard from "../views/Dashboard";
import NotAutoPublishFeedOffer from "../views/NotAutoPublishFeed/Offer";
import NotAutoPublishFeedOffers from "../views/NotAutoPublishFeed/Offers";
import Offers from "../views/Offers";
import Offer from "../views/Offer";
import NocMappings from "../views/NocMappings";
import NocDetail from "../views/NocDetail";
import HeadHunting from "../views/HeadHunting/Index.vue";
import HeadHuntingCandidate from "../views/HeadHunting/Candidate.vue";

import JobboardSpec from "../views/JobboardSpec";
import JobboardSpecForm from "../views/JobboardSpecForm";
import CreateJobboardSpec from "../views/CreateJobboardSpec";

import Users from "../views/Users";
import User from "../views/User";
import JobboardUsers from "../views/JobboardUsers";
import JobboardUser from "../views/JobboardUser";
import Team from "../views/Team";
import EditTeam from "../views/EditTeam";
import OfferAttribute from "../views/OfferAttribute";
import ChartsForm from "@/views/ChartsForm";
import MetroOffers from "../views/MetroFeedIn/Offers.vue";
import FeedIn from "../views/FeedIn/Index.vue";
import Diffusions from "../views/Diffusion/Index.vue";
import NewsletterEmailTemplates from "@/views/Emailing/NewsletterEmailTemplates.vue";
import FeedCompanies from "@/views/FeedCompanies.vue";
import Prices from "../views/Prices";
import IndeedLogs from "../views/IndeedLogs";
import IndeedPostings from "../views/IndeedPostings";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: LoginLayout,
    redirect: "login",
    children: [
      {
        path: "/login",
        name: "login",
        component: Login
      }
    ]
  },
  {
    path: "/",
    component: DefaultLayout,
    redirect: "dashboard",
    children: [
      {
        path: "sandbox",
        name: "sandbox",
        component: Sandbox
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "jobboard-spec",
        name: "jobboard-spec",
        component: JobboardSpec,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "create-jobboard-spec",
        name: "create-jobboard-spec",
        component: CreateJobboardSpec,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "update-jobboard-spec/:id",
        name: "update-jobboard-spec",
        props: true,
        component: JobboardSpecForm,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "analytics/form/:chartId?",
        name: "analytics-form",
        component: ChartsForm,
        meta: {
          requiresAuth: true
        },
        props: route => {
          if (route.params.chartId) {
            return {
              ...route.params,
              chartId: Number.parseInt(route.params.chartId)
            };
          }
          return route.params;
        }
      },
      {
        path: "companies",
        name: "companies",
        component: Companies,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "offer-attributes",
        name: "offer-attributes",
        component: OfferAttribute,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "company/:companyId",
        name: "company",
        props: true,
        component: Company,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "companies/pending",
        name: "CompanyJoinRequest",
        component: CompanyJoinRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "companies/feed",
        name: "FeedCompanies",
        component: FeedCompanies,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "feed-in",
        name: "feed-in",
        component: FeedIn,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "diffusions",
        name: "diffusions",
        component: Diffusions,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "not-auto-publish-feed-offers",
        name: "not-auto-publish-feed-offers",
        props: true,
        component: NotAutoPublishFeedOffers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "metro-feed-in-offers",
        name: "metro-feed-in-offers",
        props: true,
        component: MetroOffers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "not-auto-publish-feed-offers/:offerId",
        name: "not-auto-publish-feed-offer",
        props: true,
        component: NotAutoPublishFeedOffer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "feed-out",
        name: "feedOut",
        component: FeedOutList,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "users/employers",
        name: "employers",
        component: Users,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "users/employers/:userId",
        name: "employer",
        props: true,
        component: User,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "users/candidates",
        name: "candidates",
        component: JobboardUsers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "users/candidates/:userId",
        name: "candidate-user",
        props: true,
        component: JobboardUser,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "teams/:teamId",
        name: "team",
        props: true,
        component: Team,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "teams/:teamId/edit",
        name: "edit-team",
        props: true,
        component: EditTeam,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "emailing/newsletter-email-templates",
        name: "newsletter-email-templates",
        component: NewsletterEmailTemplates,
        meta: {
          requiresAuth: true,
          title: "Newsletter Email Templates"
        }
      },
      {
        path: "offers",
        name: "offers",
        props: route => ({
          params: route.params.requestParams
        }),
        component: Offers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "offers/:offerId",
        name: "offer",
        props: true,
        component: Offer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "noc-mappings",
        name: "noc-mappings",
        component: NocMappings,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "noc-numbers/:nocCode",
        name: "noc-detail",
        props: true,
        component: NocDetail,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "head-hunting",
        name: "head-hunting",
        component: HeadHunting,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "head-hunting/:candidateProfileId",
        name: "head-hunting-candidate",
        props: true,
        component: HeadHuntingCandidate,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "prices",
        name: "prices",
        component: Prices,
        meta: { requiresAuth: true }
      },
      {
        path: "indeed/logs",
        name: "indeed-logs",
        component: IndeedLogs,
        meta: { requiresAuth: true }
      },
      {
        path: "indeed/postings",
        name: "indeed-postings",
        component: IndeedPostings,
        meta: { requiresAuth: true }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
